export const FEATURE_NAME = '@zerops/zerops/feature/app-bar';
